export default class Snapshots {

	constructor(element) {
		this.element = element;
		this.handleInterval = this.handleInterval.bind(this);
		this.galleries = (this.element instanceof HTMLElement) ? this.element.querySelectorAll('.gigs-gallery-grid') : [];
		this.gallery2 = (this.galleries.length > 1) ? this.galleries[1] : undefined;
		this.gallery2Items = (this.gallery2 instanceof HTMLElement) ? this.gallery2.querySelectorAll('.gallery-item') : [];
		this.interval = undefined;
		this.intervalTime = 2000;
		this.visibleClass = 'gallery-item--visible';
		this.lastIndex = undefined;
	}

	init() {
		if (this.gallery2 instanceof HTMLElement) {
			this.interval = window.setInterval(this.handleInterval, this.intervalTime);
		}
	}

	destroy() {
		if (this.interval) {
			window.clearInterval(this.interval);
		}
	}

	getRandomIndex() {
		const total = this.gallery2Items.length;
		const min = Math.ceil(0);
		const max = Math.floor(total);
		const index = Math.floor(Math.random() * (max - min) + min);
		return (index === this.lastIndex) ? this.getRandomIndex() : index;
	}

	toggleItem(index = 0) {
		if (this.gallery2Items.length > 0) {
			const item = this.gallery2Items[index];
			if (item instanceof HTMLElement) {
				if (item.classList.contains(this.visibleClass)) {
					item.classList.remove(this.visibleClass);
				} else {
					item.classList.add(this.visibleClass);
				}
			}
		}
	}

	handleInterval() {
		const index = this.getRandomIndex();
		this.lastIndex = index;
		this.toggleItem(index);			
	}
}